module.exports = __webpack_public_path__ + "img/KSC07882.4fcebcc1.jpg";